// @flow

import {
  type CheckoutPaymentOptions,
} from './types';
import type { CheckoutPaymentOptionsV2 } from '@tectonics/prs/incoming-payment';

export function getCreditCardCheckoutPaymentOptions(checkoutPaymentOptions: CheckoutPaymentOptions | CheckoutPaymentOptionsV2): ImmutableArray<string> {
  return checkoutPaymentOptions.creditcard;
}
